export default __webpack_public_path__ + "static/media/briefcase.ff8e5f68.svg";